import { useMutation, useQuery } from 'react-query';
import cancelTaskApi from '../apis/cancelTask';

const { cancelTaskForMM } = cancelTaskApi;

export const useCancelTaskForMM = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return cancelTaskForMM(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};
